import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.scss'],
})
export class ForgotPasswordFormComponent implements OnInit {
  @Output() formData: EventEmitter<{
    email: string;
  }> = new EventEmitter();

  forgotPasswordForm: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  get email() {
    return this.forgotPasswordForm.get('email');
  }

  onSubmit() {
    this.formData.emit(this.forgotPasswordForm.value);
  }

  trimWhiteSpace() {
    const emailValue: string = this.forgotPasswordForm.get('email')?.value;
    this.forgotPasswordForm.get('email')?.setValue(emailValue.trim());
  }
}
